import { render, staticRenderFns } from "./InventoryEgressDrawer.vue?vue&type=template&id=61b38733"
import script from "./InventoryEgressDrawer.vue?vue&type=script&lang=js"
export * from "./InventoryEgressDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports